
/**
 * This is used to generate global errors appearing for Customer field app forms
 */
export default {
  data () {
    return {
      globalErrors: ''
    }
  },
  methods: {
    displayResponseErrors (payload) {
      let errors = ''

      Object.entries(payload).forEach(entry => {
        errors += `*${entry[0]} ${entry[1]}, `
      })

      // Replace removes last comma and space after it
      this.globalErrors = errors.replace(/,\s*$/, '')
    }
  }
}
